import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import ProtectionPlanButtonAndModal from 'components/consumer/ProtectionPlanButtonAndModal';
import usePdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/usePdpSelectedProtectionPlanId';
import useResetPdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/useResetPdpSelectedProtectionPlanId';
const PDPProtectionPlanSelectorUI = t0 => {
  const $ = _c(21);
  const {
    allProtectionPlanTypes,
    loading,
    meta,
    onProtectionPlanSelection,
    isLayoutRevamp: t1
  } = t0;
  const isLayoutRevamp = t1 === undefined ? false : t1;
  const [isProtectionModalOpen, setIsProtectionModalOpen] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsProtectionModalOpen(true);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const openProtectionModal = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsProtectionModalOpen(false);
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const closeProtectionModal = t3;
  const pdpSelectedProtectionPlanId = usePdpSelectedProtectionPlanId();
  const resetPdpSelectedProtectionPlanId = useResetPdpSelectedProtectionPlanId();
  if (loading) {
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="min-h-[66px] mt-8 mx-0 mb-0 w-full"><Placeholder type="rect" loading={true} style={{
          height: "52px"
        }} /></div>;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    return t4;
  }
  let t4;
  if ($[3] !== allProtectionPlanTypes || $[4] !== pdpSelectedProtectionPlanId) {
    t4 = pdpSelectedProtectionPlanId ? allProtectionPlanTypes.filter(singlePlan => singlePlan.plan_id === pdpSelectedProtectionPlanId)?.[0] : null;
    $[3] = allProtectionPlanTypes;
    $[4] = pdpSelectedProtectionPlanId;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const selectedProtectionPlan = t4;
  let t5;
  if ($[6] !== allProtectionPlanTypes || $[7] !== meta?.eligible_protection_planids) {
    t5 = allProtectionPlanTypes ? allProtectionPlanTypes.filter(singlePlan_0 => meta?.eligible_protection_planids.includes(singlePlan_0.plan_id)) : [];
    $[6] = allProtectionPlanTypes;
    $[7] = meta?.eligible_protection_planids;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const eligible_plans = t5;
  let t6;
  if ($[9] !== isLayoutRevamp) {
    t6 = !isLayoutRevamp && <h3 className="text-base font-bold mt-0 mx-0 mb-1.5">Protect Your Investment</h3>;
    $[9] = isLayoutRevamp;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = isLayoutRevamp ? "row" : "card";
  let t8;
  if ($[11] !== eligible_plans || $[12] !== isProtectionModalOpen || $[13] !== onProtectionPlanSelection || $[14] !== resetPdpSelectedProtectionPlanId || $[15] !== selectedProtectionPlan || $[16] !== t7) {
    t8 = <ProtectionPlanButtonAndModal variant={t7} close={closeProtectionModal} eligible_plans={eligible_plans} forPage="PDP" isOpen={isProtectionModalOpen} onSelect={onProtectionPlanSelection} openModal={openProtectionModal} removeProtectionPlan={resetPdpSelectedProtectionPlanId} selectedProtectionPlan={selectedProtectionPlan} />;
    $[11] = eligible_plans;
    $[12] = isProtectionModalOpen;
    $[13] = onProtectionPlanSelection;
    $[14] = resetPdpSelectedProtectionPlanId;
    $[15] = selectedProtectionPlan;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = <div className="min-h-[66px] mt-8 mx-0 mb-0 w-full">{t6}{t8}</div>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
PDPProtectionPlanSelectorUI.propTypes = {
  allProtectionPlanTypes: PropTypes.array,
  loading: PropTypes.bool,
  meta: PropTypes.object,
  onProtectionPlanSelection: PropTypes.func,
  isLayoutRevamp: PropTypes.bool
};
export default PDPProtectionPlanSelectorUI;